// 表单字段映射 - 英文key到中文key的映射
export const fieldMappings = {
  // Type 1: 主播合作申请
  1: {
    accountId: '账号ID',
    fansCount: '粉丝数',
    accountImages: '账号主页',
    problems: '面临问题',
    requirements: '合作诉求',
    supplements: '补充内容'
  },

  // Type 2: 品牌合作申请
  2: {
    brandName: '品牌名称',
    contactName: '联系人姓名',
    contactPhone: '联系方式',
    fileList: '品牌货盘',
    companyIntro: '公司介绍'
  },

  // Type 3: 主播合作问卷
  3: {
    anchorName: '姓名/团队名称',
    phone: '手机号',
    wechat: '微信号',
    platforms: '主要平台账号',
    'platforms.name': '平台',
    'platforms.account': '账号名',
    'platforms.fans': '粉丝量',
    categories: '擅长类目',
    otherCategory: '其他类目',
    salesData: '带货数据',
    'salesData.avgSales': '场均成交额',
    'salesData.maxGMV': '单场最高GMV',
    'salesData.coreProducts': '核心转化品',
    brandFeatures: '品牌特点',
    'brandFeatures.feature1': '品牌特点1',
    'brandFeatures.feature2': '品牌特点2',
    'brandFeatures.feature3': '品牌特点3',
    cooperationForm: '期望合作形式',
    frequency: '推广频率',
    expectations: '合作期待或建议'
  },

  // Type 4: 渠道合作问卷
  4: {
    organizationName: '机构名称',
    channelTypes: '渠道类型',
    otherChannelType: '其他渠道类型',
    coverageArea: '渠道覆盖区域',
    userScale: '用户规模/年营业额',
    hasSalesTeam: '是否有销售团队',
    teamSize: '团队人数',
    teamFunction: '团队职能',
    coreAdvantages: '核心资源优势',
    privateDomainSize: '私域流量池人数',
    otherAdvantage: '其他优势',
    expectations: '合作期待或建议'
  },

  // Type 5: 合作基地招募
  5: {
    organizationName: '机构/个人名称',
    contactName: '联系人姓名',
    position: '职位',
    phone: '联系电话',
    organizationType: '机构性质',
    venueAddress: '场地详细地址',
    venueTypes: '场地类型',
    venueArea: '场地面积',
    'venueArea.total': '总面积',
    'venueArea.available': '可合作面积',
    currentStatus: '当前使用状态',
    partialVacantArea: '可腾挪空间面积',
    venueImages: '场地实景照片',
    localResources: '本地资源',
    customerGroupSize: '现有客户群体人数',
    otherResources: '其他资源',
    hasTeam: '是否有可投入人力团队',
    teamSize: '团队人数',
    teamRoles: '可承接岗位',
    cooperationExpectations: '希望我方赋能的方面',
    otherExpectations: '其他期望',
    additionalInfo: '其他建议或诉求'
  }
}

// 递归转换对象key为中文
export function convertKeysToChinese(data, type) {
  if (!data || typeof data !== 'object') {
    return data
  }

  const mapping = fieldMappings[type]
  if (!mapping) {
    return data
  }

  const result = {}
  
  // 遍历原始数据的所有字段
  for (const [key, value] of Object.entries(data)) {
    // 检查数组
    if (Array.isArray(value)) {
      // 处理数组，如 platforms
      const arrayResult = value.map((item, index) => {
        if (typeof item === 'object' && item !== null) {
          // 处理数组中的对象
          const itemResult = {}
          for (const [itemKey, itemValue] of Object.entries(item)) {
            const itemPath = `${key}.${itemKey}`
            if (mapping[itemPath]) {
              itemResult[mapping[itemPath]] = itemValue
            } else {
              itemResult[itemKey] = itemValue
            }
          }
          // 将对象转换为 key:value, key:value 格式
          const objectString = Object.entries(itemResult)
            .map(([k, v]) => `${k}：${v}`)
            .join('，')
          return `${index + 1}、${objectString}`
        } else {
          return `${index + 1}、${item}`
        }
      })
      // 数组字段也需要转换为中文key，并格式化为纯文本
      const chineseKey = mapping[key] || key
      result[chineseKey] = '\n' + arrayResult.join('\n')
    }
    // 检查嵌套对象
    else if (typeof value === 'object' && value !== null) {
      // 处理嵌套对象，如 salesData, brandFeatures, venueArea
      const nestedResult = {}
      for (const [nestedKey, nestedValue] of Object.entries(value)) {
        const nestedPath = `${key}.${nestedKey}`
        if (mapping[nestedPath]) {
          nestedResult[mapping[nestedPath]] = nestedValue
        } else {
          nestedResult[nestedKey] = nestedValue
        }
      }
      // 嵌套对象也需要转换为中文key，并格式化为纯文本
      const chineseKey = mapping[key] || key
      const objectString = Object.entries(nestedResult)
        .map(([k, v]) => `${k}：${v}`)
        .join('，')
      result[chineseKey] = '\n' +objectString
    } else {
      // 检查是否有直接映射
      if (mapping[key]) {
        result[mapping[key]] = value
      } else {
        // 如果映射中没有找到，保持原key
        result[key] = value
      }
    }
  }
  
  return result
}

// 获取指定类型的字段映射
export function getFieldMapping(type) {
  return fieldMappings[type] || {}
}
